<template>
  <div id="index" class="index">
    <div class="addANewProduct">
      <button class="by-button--primary add-button" @click="addOrUpdateHandle()">+ 新增我的商品</button>
    </div>
    <div class="card-main">
      <div v-for="(item, index) in commodityList" :key="index" class="card-item">
        <div class="img-product">
          <img v-if="item.pictureUrl" :src="item.pictureUrl| toUrl()" width="120px" height="120px">
          <img
            v-if="!item.pictureUrl"
            src="../../../assets/img/manage/settings/default_product.jpg"
            width="120px"
            height="120px"
          >
        </div>
        <div class="card-content">
          <p>{{ item.nameCh }}</p>
          <div style="margin-bottom: 4px;">品牌：{{ item.brand }}</div>
          <div>型号：{{ item.model }}</div>
        </div>
        <div class="card-button">
          <span @click="deleteHandle(item.id)">删除</span>
          <button class="by-common--primary" @click="addOrUpdateHandle(item.id)">修改</button>
        </div>
      </div>
    </div>
    <EditDialog :value="isEditDialog" @close="()=>{ isEditDialog = false}">
      <template v-slot:title>
        <div>{{ title }}</div>
      </template>
      <template v-slot:body>
        <Edit ref="Edit" @close="()=>{isEditDialog = false}" @refresh="refresh" />
      </template>
      <template v-slot:footer />
    </EditDialog>
  </div>
</template>

<script>
import EditDialog from '../../../components/Dialog/Dialog.vue'
import Edit from './edit.vue'
import request from '@/utils/request'
import define from '@/utils/define'
import {
  getCookie
} from '@/utils/cookiejs'
export default {
  name: 'Index',
  components: {
    // 组件的引用
    Edit,
    EditDialog
  },
  props: {
    // 父辈向子辈传参
  },
  data() {
    return {
      isEditDialog: false,
      commodityList: [],
      token: '',
      title: ''
    }
  },
  computed: {
    // 计算属性
  },
  watch: {
    // 监测变化
  },
  created() {
    // 实例被创建之后执行代码
    this.token = getCookie('token')
    // console.log(this.token)
    if (this.token) {
      this.getCommodity()
    }
  },
  mounted() {
    // 页面进入时加载内容
  },
  methods: {
    // 方法
    getCommodity() {
      request({
        url: `/api/Wms/OrderCargo/GetCustomerCargoList`,
        method: 'GET',
        headers: {
          Authorization: this.token
        }
      }).then(res => {
        this.commodityList = res.data

        if (res.data.length === 0) {
          this.addOrUpdateHandle()
        }
      })
    },
    deleteHandle(id) {
      this.$confirm('确定删除该商品?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        request({
          url: `/api/Wms/OrderCargo/DeleteCustomerCargo/${id}`,
          method: 'DELETE',
          headers: {
            Authorization: this.token
          }
        }).then(res => {
          this.$message({
            type: 'success',
            message: res.msg,
            onClose: () => {
              this.getCommodity()
            }
          })
        })
      }).catch(() => {})
    },
    addOrUpdateHandle(id) {
      this.isEditDialog = true
      const initId = id || 0
      if (!initId) {
        this.title = '新增商品'
      } else {
        this.title = '编辑商品'
      }
      this.$nextTick(() => {
        this.$refs.Edit.init(id)
      })
    },
    refresh(isrRefresh) {
      this.isEditDialog = false
      if (isrRefresh) this.getCommodity()
    }
  }
}
</script>
<style scoped lang='scss'>
	.index {
		height: 800px;
		overflow: auto;
	}

	.addANewProduct {
		position: fixed;
		top: 100px;
		right: 30px;
		float: right;

		.add-button {
			width: 186px;
			height: 40px;
			font-size: 16px;
			font-family: D-DINExp, D-DINExp;
			font-weight: bold;
		}
	}

	.img-product {
		margin: 24px 0 24px 24px;
	}

	.card-main {
		// display: flex;
		overflow: auto;
		width: 100%;
		display: grid;
		grid-template-columns: repeat(3, 1fr);
		gap: 15px;
		/* 元素间距 */
    overflow: auto;
    max-height: 720px;

		.card-item {
			height: 168px;
			background: #FFFFFF;
			border-radius: 8px;
			display: flex;
			justify-content: space-between;
			align-items: center;

			.card-content {
				flex: 1;
				text-align: left;
				margin-left: 16px;

				p {
					font-size: 17px;
					line-height: 24px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 600;
					color: #333333;
					padding: 4px 0;
					margin: 0 0 8px 0;
				}

				div {
					font-size: 14px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 400;
					color: #333333;
					line-height: 20px;
					padding: 2px 0;
				}
			}

			.card-button {
				width: 144px;
				align-self: flex-start;
				margin-top: 24px;
				margin-right: 24px;

				span {
					font-size: 16px;
					font-family: PingFangSC, PingFang SC;
					font-weight: 500;
					color: #E90606;
					line-height: 22px;
					cursor: pointer;
					margin-right: 23px;
				}

				button {
					width: 64px;
					height: 32px;
					cursor: pointer;
				}
			}
		}
	}

	::v-deep .dialog {
		width: 1032px;
		height: 715px;

		.dialog__header {
			text-align: left;
		}

		.dialog__body {
			padding: 0px;
		}

		.el-form-item--medium {
			width: 47%;
			margin-bottom: 0px
		}

		.commodities {
			height: auto;

			.main-info {
				padding: 0px;
			}
		}
	}
</style>
